// API Configuration
export const BASE_URL = 'https://updates-backend-api-beebc8cc747c.herokuapp.com/api';
